import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BottomNavbar from "../components/BottomNavbar";
import {
  fetchJurnalMingguan,
  fetchJurnalMingguanFoto,
  downloadJurnalMingguanPDF,
} from "../services/jurnalMingguanService";

function FotoKegiatan({ foto }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;

    if (!foto?.id) {
      setFailed(true);
      return undefined;
    }

    fetchJurnalMingguanFoto(foto.id)
      .then((loadedUrl) => {
        objectUrl = loadedUrl;
        if (cancelled) {
          URL.revokeObjectURL(loadedUrl);
          return;
        }
        setUrl(loadedUrl);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [foto?.id]);

  return (
    <div className="d-flex align-items-start mb-2">
      {url && !failed ? (
        <img
          src={url}
          alt="Foto kegiatan"
          style={{
            width: 60,
            height: 60,
            objectFit: "cover",
            borderRadius: 8,
            marginRight: 12,
          }}
        />
      ) : (
        <div
          className="d-flex align-items-center justify-content-center text-muted bg-light"
          style={{
            width: 60,
            height: 60,
            borderRadius: 8,
            marginRight: 12,
            fontSize: 12,
            textAlign: "center",
          }}
        >
          {failed ? "Foto tidak tersedia" : "Memuat foto..."}
        </div>
      )}
      <p className="mb-0">{foto.tanggal} {foto.deskripsi}</p>
    </div>
  );
}

function JurnalMingguan() {
  const navigate = useNavigate();
  const siswaId = localStorage.getItem("user_id");

  const [jurnals, setJurnals] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMinggu, setSelectedMinggu] = useState("");
  const [downloading, setDownloading] = useState(false);

  const loadJurnals = useCallback(
    async (pageNumber = 1) => {
      if (!siswaId) return;
      setLoading(true);
      const result = await fetchJurnalMingguan(siswaId, pageNumber);
      if (result.success) {
        setJurnals((prev) =>
          pageNumber === 1 ? result.data.data : [...prev, ...result.data.data]
        );
        setHasMore(result.data.next_page_url !== null);
        setPage(pageNumber);
      }
      setLoading(false);
    },
    [siswaId]
  );

  useEffect(() => {
    loadJurnals(1);
  }, [loadJurnals]);

  const handleDownload = async () => {
    if (!selectedMinggu) {
      alert("Pilih minggu terlebih dahulu.");
      return;
    }

    setDownloading(true);
    const result = await downloadJurnalMingguanPDF(siswaId, selectedMinggu);
    if (!result.success) {
      alert(result.message);
    } else {
      setModalOpen(false);
    }
    setDownloading(false);
  };

  return (
    <div
      className="container"
      style={{ minHeight: "100vh", paddingBottom: 80 }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center my-4">
        <div className="d-flex align-items-center">
          <button className="btn p-0 text-dark" onClick={() => navigate(-1)}>
            ←
          </button>
          <h5 className="ms-3 mb-0 fw-bold">Riwayat Jurnal Mingguan</h5>
        </div>
        <button
          className="btn btn-primary"
          style={{
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            padding: 0,
            fontSize: "20px",
          }}
          onClick={() => navigate("/input-jurnal-mingguan")}
          title="Tambah Jurnal Mingguan"
        >
          <i className="bi bi-plus-lg"></i>
        </button>
      </div>

      {/* Jurnal List */}
      {jurnals.length === 0 && !loading ? (
        <div className="text-center text-muted" style={{ height: "50vh" }}>
          Tidak ada data jurnal mingguan.
        </div>
      ) : (
        jurnals.map((item, index) => (
          <div
            key={index}
            className="mb-3 p-3"
            style={{
              backgroundColor: "#f1f4f9",
              borderRadius: 16,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <p className="fw-bold mb-2">Minggu ke-{item.minggu_ke}</p>
            <p>
              <strong>Nama Pekerjaan:</strong> {item.nama_pekerjaan}
            </p>
            <p>
              <strong>Perencanaan Kegiatan:</strong>
              <br />
              {item.perencanaan_kegiatan}
            </p>
            <p>
              <strong>Pelaksanaan Kegiatan:</strong>
            </p>
            {item.foto?.map((foto, idx) => (
              <FotoKegiatan key={foto.id || idx} foto={foto} />
            ))}
          </div>
        ))
      )}

      {/* Loading Spinner */}
      {loading && (
        <div className="text-center my-3">
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}

      {/* Load More */}
      {!loading && hasMore && (
        <div className="text-center mt-3">
          <button
            className="btn btn-outline-primary"
            onClick={() => loadJurnals(page + 1)}
          >
            Tampilkan Lebih Banyak
          </button>
        </div>
      )}

      {/* Download Button */}
      <button
        className="btn btn-primary position-fixed"
        style={{
          bottom: 100,
          right: 20,
          borderRadius: 16,
          padding: "10px 16px",
          display: "flex",
          alignItems: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
        onClick={() => setModalOpen(true)}
      >
        <i className="bi bi-download me-2" /> Download
      </button>

      <BottomNavbar />

      {/* Modal */}
      {modalOpen && (
        <div
          className="modal d-block"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999,
            width: "100%",
            height: "100%",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Download Jurnal Mingguan</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalOpen(false)}
                />
              </div>
              <div className="modal-body">
                <label className="form-label">Pilih Minggu ke-</label>
                <div style={{ maxHeight: 200, overflowY: "auto" }}>
                  <select
                    className="form-select"
                    value={selectedMinggu}
                    onChange={(e) => setSelectedMinggu(e.target.value)}
                  >
                    <option value="">-- Pilih Minggu --</option>
                    {Array.from({ length: 25 }, (_, i) => (
                      <option key={i + 1} value={i + 1}>
                        Minggu ke-{i + 1}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setModalOpen(false)}
                >
                  Batal
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleDownload}
                  disabled={downloading}
                >
                  {downloading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />{" "}
                      Mengunduh...
                    </>
                  ) : (
                    "Download PDF"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default JurnalMingguan;
